
import { map, ofArray, singleton, mapIndexed, concat, isEmpty } from "../fable_modules/fable-library-js.5.13.0/List.js";
import * as react from "react";
import { keyValueList } from "../fable_modules/fable-library-js.5.13.0/MapUtil.js";

/**
 * One chord drawn as the keys to press: [Ctrl]+[Alt]+[-].
 * 
 * Takes the key names rather than a shortcut, so that a caller showing a platform other than the
 * one it is running on can do so - the shortcut list in Info shows both. Empty means the shortcut
 * has no chord on that platform, which is said in words: an empty row would read as "no key
 * needed".
 */
export function render(parts) {
    if (isEmpty(parts)) {
        return react.createElement("span", {}, "(none)");
    }
    else {
        const children_6 = concat(mapIndexed((i, cap) => {
            if (i === 0) {
                return singleton(cap);
            }
            else {
                return ofArray([react.createElement("span", {
                    className: "keyCapPlus",
                }, "+"), cap]);
            }
        }, map((k) => react.createElement("span", {
            className: "keyCap",
        }, k), parts)));
        const props_6 = singleton(["style", {
            whiteSpace: "nowrap",
        }]);
        return react.createElement("span", keyValueList(props_6, 1), ...children_6);
    }
}

